import { styled, textFieldClasses, inputBaseClasses, svgIconClasses, Popover as Popover$1, listClasses, paperClasses, MenuItem as MenuItem$1, Typography, IconButton } from "@mui/material";
import { keyframes } from "@emotion/react";
import { TextField as TextField$1 } from "../../utils/shared/TextField.js";
const Container = styled("div")(() => ({
  display: "flex",
  flexDirection: "row",
  position: "relative"
}));
const Flag = styled("div")(({ theme, image }) => ({
  width: theme.spacing(2.25),
  height: theme.spacing(2.25),
  flexBasis: theme.spacing(2.25),
  minWidth: theme.spacing(2.25),
  backgroundImage: `url(${image})`,
  border: `1px solid rgb(255, 255, 255)`,
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  borderRadius: "50%"
}));
const onAutofillStart = keyframes`
  from {}
  to {}
`;
const onAutofillCancel = keyframes`
  /* Adding this comment so emotion will generate a different animation name than onAutofillStart */
  from {}
  to {}
`;
const TextField = styled(TextField$1)(() => ({
  [`&.${textFieldClasses.root} .${inputBaseClasses.input}`]: {
    paddingLeft: 0,
    ["&:-webkit-autofill"]: {
      animationName: onAutofillStart
    },
    ["&:not(:-webkit-autofill)"]: {
      animationName: onAutofillCancel
    }
  }
}));
const Button = styled("button")(({ theme }) => ({
  cursor: "pointer",
  appearance: "none",
  border: "none",
  padding: 0,
  display: "flex",
  alignItems: "center",
  position: "absolute",
  left: theme.spacing(2),
  top: "24px",
  zIndex: 20,
  backgroundColor: "transparent",
  [`& .${svgIconClasses.root}`]: {
    fontSize: "16px",
    color: theme.palette.grey[800]
  }
}));
const Popover = styled(Popover$1)(({ theme }) => ({
  [`& .${listClasses.root}`]: {
    padding: 0
  },
  [`& .${paperClasses.root}`]: {
    maxHeight: "300px",
    maxWidth: "300px",
    borderRadius: "0 0 4px 4px",
    boxShadows: theme.shadows[4]
  }
}));
const MenuItem = styled(MenuItem$1)(({ theme }) => ({
  ...theme.typography["Lato Body 1"],
  color: theme.palette.grey[800],
  padding: theme.spacing(1.5, 2),
  "&.Mui-selected": {
    backgroundColor: theme.palette.grey[100]
  },
  "&:hover": {
    backgroundColor: theme.palette.primary[50]
  }
}));
const MenuItemText = styled(Typography)(({ theme }) => ({
  color: theme.palette.grey[800],
  marginLeft: theme.spacing(1),
  fontSize: "16px"
}));
const CallingCode = styled("span")(() => ({
  padding: "22px 6px 3px 40px",
  zIndex: 2
}));
const SearchClearButton = styled(IconButton)(() => ({
  width: "30px",
  height: "30px",
  zIndex: 2,
  [`& .${svgIconClasses.root}`]: {
    fontSize: "20px"
  }
}));
export {
  Button,
  CallingCode,
  Container,
  Flag,
  MenuItem,
  MenuItemText,
  Popover,
  SearchClearButton,
  TextField,
  onAutofillCancel,
  onAutofillStart
};
